import React, { useEffect, useState } from 'react';
import './overview.css';
import Nav from '../components/layout/nav';
import Analytics from '../components/common/analytics';
import { supabase } from '../supabase';


import a1 from '../assets/a1Icon.svg';
import a2 from '../assets/a2Icon.png';
import a3 from '../assets/a3Icon.png';
import a4 from '../assets/a4Icon.png';

const Overview = () => {
  const [bookings, setBookings] = useState([]);
  const [users, setUsers] = useState([]);
  const [events, setEvents] = useState([]);
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    setLoading(true);

    const { data: bookingsData, error: bookingsError } =
      await supabase.from('ticket_orders').select('*');

    const { data: usersData, error: usersError } =
      await supabase.from('users').select('*');

    const { data: eventsData, error: eventsError } =
      await supabase.from('events').select('*').order('id', { ascending: false });

    const { data: reviewsData, error: reviewsError } =
      await supabase.from('reviews').select('*');

    if (bookingsError) console.error('Bookings error:', bookingsError);
    if (usersError) console.error('Users error:', usersError);
    if (eventsError) console.error('Events error:', eventsError);
    if (reviewsError) console.error('Reviews error:', reviewsError);

    setBookings(bookingsData || []);
    setUsers(usersData || []);
    setEvents(eventsData || []);
    setReviews(reviewsData || []);

    setLoading(false);
  };

  return (
    <div className="dashboard">
      <Nav />

        <div className="mainarea">
            <div className="navtoppart">

        <div className="welcomebcakdiv">
        <h6 className="welcomebacktext">Welcome back</h6>
        <h6 className="admintitle">Admin Dashboard</h6>
        </div>

        <div className="profileandnotidiv">

        <div className="notidiv">
            <div className="notiicon"></div>
        </div>

        <div className="profilediv"></div>

        </div>

    </div>


        <div className="pagecenter">
          <div className="homecontainer">
            
            <section>

              <div className="titlediv">
                <h1>Dashboard Overview</h1>
                <h2>Monitor your fashion week performance</h2>
              </div>

              {loading && <p className="content-loading">Loading...</p>}

              <div className="analticsdiv">

                <Analytics
                  anaicon={a1}
                  anaprecent="+12.5%"
                  amountt={bookings.length}
                  anatotall="Bookings"
                />

                <Analytics
                  anaicon={a2}
                  anaprecent="+8.2%"
                  amountt={users.length}
                  anatotall="Users"
                />

                <Analytics
                  anaicon={a3}
                  anaprecent="+5.1%"
                  amountt={events.length}
                  anatotall="Events"
                />

                <Analytics
                  anaicon={a4}
                  anaprecent="+3.9%"
                  amountt={reviews.length}
                  anatotall="Reviews"
                />

              </div>
              <div className="bookingtrendscharts">

                <div className="charts">
                  <h6 className="chartstitle">Bookings Overview</h6>

                  <div className="chartsdiv">
                    <div className="bars">

                      <div className="barwrap mon">
                            <div className="bar"></div>
                            <p>Mon</p>
                        </div>
                        <div className="barwrap tue">
                            <div className="bar"></div>
                            <p>Tue</p>
                        </div>
                        <div className="barwrap wed">
                            <div className="bar"></div>
                            <p>Wed</p>
                        </div>
                      <div className="barwrap thu">
                        <div className="bar">
                            </div><p>Thu</p>
                        </div>
                        <div className="barwrap fri">
                            <div className="bar"></div>
                            <p>Fri</p>
                        </div>
                        <div className="barwrap sat">
                            <div className="bar"></div>
                            <p>Sat</p>
                        </div>
                        <div className="barwrap sun">
                            <div className="bar"></div>
                            <p>Sun</p
                        ></div>

                    </div>
                  </div>
                </div>

                <div className="charts">
                  <h6 className="chartstitle">Resume Overview</h6>

                  <div className="chartsdiv">
                    <div className="bars">

                        <div className="barwrap design">
                            <div className="bar"></div>
                            <p>Design</p>
                        </div>
                        <div className="barwrap runway">
                            <div className="bar"></div>
                            <p>Runway Shows</p>
                        </div>
                        <div className="barwrap styling">
                            <div className="bar"></div><
                                p>Styling</p>
                        </div>
                        <div className="barwrap branding">
                            <div className="bar"></div>
                            <p>Brand Presence</p>
                        </div>
                        <div className="barwrap media">
                            <div className="bar"></div>
                            <p>Media</p>
                        </div>

                    </div>
                  </div>
                </div>

              </div>


              <div className="table">

                <h6 className="tabletitle">Upcoming Shows</h6>

                <div className="tableheader">
                  <p>Designer</p>
                  <p>Collection</p>
                  <p>Date</p>
                  <p>Location</p>
                  <p>Status</p>
                </div>

                {events.map((event) => (
                  <div className="tablerow" key={event.id}>

                    <p>{event.designer || '-'}</p>
                    <p>{event.collection || event.title || '-'}</p>
                    <p>{event.event_date || '-'}</p>
                    <p>{event.location || '-'}</p>

                    <span className={`status ${event.status || 'upcoming'}`}>
                      {event.status || 'Upcoming'}
                    </span>

                  </div>
                ))}

              </div>

            </section>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Overview;